module.exports = __webpack_public_path__ + "34736292/img/pdf-icon.79f04a36.svg";